import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialog,MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatChipsModule } from '@angular/material/chips';
import { FormGroup, FormBuilder, FormControl, ReactiveFormsModule, FormsModule} from '@angular/forms';
import { Observable, EMPTY } from 'rxjs';
import { map } from 'rxjs/operators';
import { TeamService } from '../../services/team.service';
import { ModelVariant, TeamVariant } from 'src/app/shared/models/type-list';
import { ReassignWorkDialogComponent } from './reassign-work-dialog/reassign-work-dialog.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { NonActiveWorkDialogComponent } from './non-active-work-dialog/non-active-work-dialog.component';

@Component({
  selector: 'app-variant-config-dialog',
  templateUrl: './variant-config-dialog.component.html',
  styleUrl: './variant-config-dialog.component.scss',
  standalone: true,
  imports: [CommonModule, MatDialogModule, ReactiveFormsModule, FormsModule, MatChipsModule, MatFormFieldModule, MatIconModule, MatAutocompleteModule,
    MatProgressSpinner, MatSelectModule, MatInputModule, MatButtonModule]
})
export class VariantConfigDialogComponent implements OnInit{

  team_info: any = {team_id: 0, team_name: '', version_id: 0};
  
  fg_VariantConfig: FormGroup = <FormGroup>{};
  
  modelVariantList: ModelVariant[] = [];
  teamVariantList: TeamVariant[] = [];
  pitchVariantList: TeamVariant[] = [];
  variantsWithWork: TeamVariant[] = [];


  teamVariantConfig: TeamVariant = <TeamVariant>{};

  disableVariantSelection: boolean = false;
  disableModelSelection: boolean = false;
  isVariantNameDirty: boolean = false;

  selectedModelVariants: ModelVariant[] = [];
  selectedModelsList: string[] = [];

  isBusy: boolean = false;

  returnData: any = {};
  baseVariant: TeamVariant = <TeamVariant>{};
  baseVariantID: number = 0;

  transferWork: boolean = false;
  transferFromVariant: TeamVariant = <TeamVariant>{};
  pitchConfigID: number = 0;

  currentVariantStatus: any = { variant_name: '', matching: false, rename: false };
  currentVariant: any;

  variantStatus: string = 'active';
  variantMsg: string = '';

  

  constructor(
    public dialogRef: MatDialogRef<VariantConfigDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public inData: any,
    private svc_Team: TeamService,
    private fb: FormBuilder,
    private dialog: MatDialog
  ){}


  ngOnInit(): void {
    console.log('Variant Config Data', this.inData)
    this.team_info.plant_name = this.inData.plant_name? this.inData.plant_name: '';
    this.team_info.team_id = this.inData.team_id? this.inData.team_id: 0;
    this.team_info.team_name = this.inData.team_name? this.inData.team_name: '';
    this.team_info.version_id = this.inData.version_id? this.inData.version_id: 0;
    this.pitchConfigID = this.inData.pitch_config_id? this.inData.pitch_config_id: 0;
    this.pitchVariantList = this.inData.variant_list? this.inData.variant_list: [];
    this.variantsWithWork = this.pitchVariantList.filter(variant => variant.total_work != undefined && variant.total_work > 0)
    
    this.fg_VariantConfig = this.fb.group({
      f_ExistingVariant: new FormControl(0),
      f_ModelVariants: new FormControl([]),
      f_VariantName: new FormControl('')
    })

    let baseIndex = this.pitchVariantList.findIndex(variant => variant.base_variant_id == 1)
    if (baseIndex != -1){
      this.baseVariant = this.pitchVariantList[baseIndex];
    };

    this.fg_VariantConfig.controls['f_VariantName'].valueChanges.subscribe((value)=>{
      console.log('Variant Name:', value, this.fg_VariantConfig.controls['f_VariantName'].dirty)
      if (this.fg_VariantConfig.controls['f_VariantName'].dirty) {
        // If the user types anything, mark it as dirty to prevent overwrites.
        this.isVariantNameDirty = true;
      }
      if (this.currentVariantStatus.matching && this.currentVariantStatus.variant_name != value){
        this.currentVariantStatus.rename = true;
      } else {
        this.currentVariantStatus.rename = false;
      }
    });



    this.fg_VariantConfig.controls['f_ExistingVariant'].valueChanges.subscribe((value)=>{
      if (value.variant_id != -1) {
        this.teamVariantConfig = value;
        this.teamVariantConfig.variant_status = this.variantStatus;
        this.teamVariantConfig.variant_msg = this.variantMsg;
        this.disableModelSelection = true;
        this.fg_VariantConfig.get('f_ModelVariants')?.disable({emitEvent: false});
      } else {
        this.fg_VariantConfig.get('f_ExistingVariant')?.setValue('');
        this.teamVariantConfig = <TeamVariant>{};
        this.disableModelSelection = false;
        this.fg_VariantConfig.get('f_ModelVariants')?.enable({emitEvent: false});
      }
    });

    this.fg_VariantConfig.get('f_ModelVariants')?.valueChanges.subscribe((value)=>{
      this.selectedModelVariants = value;
      this.currentVariant = this.compareToTeamVariants();

      console.log(this.currentVariant);
      this.currentVariantStatus.matching = this.currentVariant.variant_id != 0;
      this.currentVariantStatus.variant_name = this.currentVariant.variant_name;
      this.selectedModelsList = this.selectedModelVariants.map(model => model.model_name);

      if (!this.isVariantNameDirty) {
        if (this.currentVariantStatus.matching) {
          this.fg_VariantConfig.controls['f_VariantName'].setValue(this.currentVariantStatus.variant_name, { emitEvent: false });
        } else {
          const teamVariantName = this.selectedModelVariants.map(model => model.model_name.trim()).join('/');
          this.fg_VariantConfig.controls['f_VariantName'].setValue(teamVariantName, { emitEvent: false });
        }
      } else {
        if (this.currentVariantStatus.matching) {
          this.currentVariantStatus.rename = true;
        } else {
          this.currentVariantStatus.rename = false; 
        }
      }

      if (this.selectedModelVariants.length > 0) {
        this.disableVariantSelection = true;
        this.fg_VariantConfig.get('f_ExistingVariant')?.disable({emitEvent: false});
      } else {
        this.disableVariantSelection = false;
        this.fg_VariantConfig.get('f_ExistingVariant')?.enable({emitEvent: false});
      }
    });


    this.getTeamVariants();
  }

  getTeamVariants(){
    // get a list of team variants that have already been defined for the team
    this.svc_Team.getTeamVariant(this.team_info.team_id, this.team_info.version_id).subscribe(out=>{
      let holdTeamVariantList = out.Body;
      console.log('Hold Team Variants:', holdTeamVariantList)

      holdTeamVariantList.forEach(variant => {
        const modelVariants = variant.model_variants ?? [];
        if (modelVariants.length > 0 && !modelVariants.some(model => model.deleted_flag == 1)) {
          this.teamVariantList.push(variant);
        }
      })

      let baseIndex = this.teamVariantList.findIndex(variant => variant.base_variant_id == 1)

      this.svc_Team.getModelVariant(this.team_info.team_id).subscribe(out=>{
        this.modelVariantList = out.Body;
        if (baseIndex != -1){
          const baseVariant = this.teamVariantList[baseIndex];
          if (baseVariant) {
            this.baseVariant = baseVariant;
            this.baseVariantID = baseVariant.variant_id;
            (baseVariant.model_variants ?? []).forEach(model =>{
              this.modelVariantList = this.modelVariantList.filter(variant=>variant.model_id != model.model_id)
            });
          }
        };
      
        //variant_id is set to -1 to prevent '< Unselect Variant >' from being mistaken as the base variant
        this.teamVariantList.push({ variant_id: -1, variant_name: '< Unselect Variant >'})

        console.log('Model Variants:', this.modelVariantList)
        console.log('Team Variants:', this.teamVariantList)
      });
    })

  }

  onVariantNameBlur() {
    const variantNameControl = this.fg_VariantConfig.controls['f_VariantName'];
    // If the user leaves the field and it's empty, revert to auto-generated name.
    if (variantNameControl.value.trim() === '' || this.currentVariantStatus.variant_name === variantNameControl.value) {
      this.isVariantNameDirty = false;
      if (this.currentVariantStatus.matching) {
        variantNameControl.setValue(this.currentVariantStatus.variant_name, { emitEvent: false });
        this.currentVariantStatus.rename = false;
      } else {
        const teamVariantName = this.selectedModelVariants.map(model => model.model_name.trim()).join('/');
        variantNameControl.setValue(teamVariantName, { emitEvent: false });
      }
    }
  }

  onNoClick():void{
    this.dialogRef.close()
  }

  onSubmit(){
    this.isBusy = true;
    let returnData: any = { variant: { variant_id: 0, variant_name: '', model_variants: [], variant_status: this.variantStatus, variant_msg: this.variantMsg }, 
        removeVariant: this.transferFromVariant, update_pitch: this.transferWork };
    let obs: Observable<any> = EMPTY;
    const teamVariantName = this.fg_VariantConfig.get('f_VariantName')?.value ?? '';
    try {
      if (this.disableVariantSelection && this.selectedModelVariants.length > 0) {
        // Creating a new variant from selected models
        console.log('Team Variant Name: ', teamVariantName);
        if (!this.currentVariantStatus.matching) {
          console.debug('No match. Creating new variant.');
          obs = (this.svc_Team.createTeamVariant(this.team_info.team_id, teamVariantName, this.selectedModelVariants)
                    .pipe(map(val => ['CREATE', val] as const)));
        } else {
          console.debug('Match found.');
          this.currentVariant.variant_name = teamVariantName; // Reflect the change locally.
          returnData.variant = this.currentVariant;
          if (this.currentVariantStatus.rename){
            console.debug('Variant rename.')
            obs = (this.svc_Team.updateTeamVariantName(this.team_info.team_id, this.currentVariant.variant_id, teamVariantName)
                      .pipe(map(val => ['RENAME', val] as const)));
            
          } 
        }
      } else if (this.disableModelSelection && this.teamVariantConfig.variant_id) {
        // Using an existing variant
        returnData.variant = this.teamVariantConfig;
      }

      console.log(obs)
      obs.subscribe({
          next: (result) => {
            console.log(result[0], result[1].Body);
            if (result[0] == 'CREATE'){
              returnData.variant.variant_id = result[1].Body['VARIANTID'];
              returnData.variant.variant_name = teamVariantName;
              returnData.variant.model_variants = this.selectedModelVariants;
            } 
          },
          complete: () => {
            let transferObs: Observable<any> = EMPTY;
            if (this.transferWork && returnData.variant.variant_id) {
              transferObs = (this.svc_Team.transferPitchWork(this.team_info.plant_name, this.team_info.team_id, this.team_info.version_id,
                this.pitchConfigID, this.transferFromVariant.variant_id, this.pitchConfigID, returnData.variant.variant_id)
                .pipe(map(val => ['TRANSFER', val] as const)));
            
            }              
            transferObs.subscribe({
              complete: () => {
                console.debug('Transfer Work finished');
                this.isBusy = false;
                this.dialogRef.close(returnData);
              }
            });
          }
        });  

    } catch (error) {
      console.error('Error during variant submission:', error);
    }
  }

  compareToTeamVariants():TeamVariant{
    console.debug('Selected Model Variants:', this.selectedModelVariants)
    let existingVariant: TeamVariant = { variant_id: 0, variant_name: '', model_variants:[] };
    let sModelVariants: any[] = [];

    this.teamVariantList.forEach(variant=>{
      sModelVariants = this.selectedModelVariants.map((model)=> { return { model_id: model.model_id, model_name: model.model_name }; });
      
      if (variant.model_variants!=undefined && sModelVariants != undefined){
        if (compareArrays(variant.model_variants, sModelVariants) ){
          console.debug('Matching Variant:', variant)
          existingVariant = variant
        }
      }
    });

    return existingVariant;

  }

  onReassign(){
    console.log(this.pitchVariantList)
    this.variantsWithWork = this.pitchVariantList.filter(variant => variant.total_work != undefined && variant.total_work > 0)
    console.log(this.variantsWithWork)
    const dialogRef = this.dialog.open(ReassignWorkDialogComponent,{
      width: '500px',
      data: { variants: this.variantsWithWork, base_variant_id: this.baseVariantID }
    });

    dialogRef.afterClosed().subscribe(result =>{
      // add team variant to variant list
      console.log(result)
      if (result != undefined){
        if ( result.variant ){
          console.log(result.variant)
          this.transferWork = true;
          this.transferFromVariant = result.variant;
        } else {
          this.transferWork = false;
          this.transferFromVariant = <TeamVariant>{};
        }
      }
    })
  }

  onAssignNonActive(){
    const dialogRef = this.dialog.open(NonActiveWorkDialogComponent,{
      width: '600px',
      data: this.team_info
    });

    dialogRef.afterClosed().subscribe(result =>{
      // add team variant to variant list
      console.log(result)
      if (result != undefined){
        if ( result.variant ){
          console.log(result.variant)
          this.variantStatus = result.variant.variant_status;
          this.variantMsg = result.variant.variant_msg;
          this.teamVariantConfig.variant_status = this.variantStatus;
          this.teamVariantConfig.variant_msg = this.variantMsg;
        }
      }
    })
  }

  get modelNamesText(): string {

    if(this.teamVariantConfig.model_variants?.length === 1){
      return `(Models: ${this.teamVariantConfig.model_variants?.map(model => model.model_name).join(', ')})`
    } else if(this.teamVariantConfig.model_variants && this.teamVariantConfig.model_variants.length > 1){
      return `(Models: ${this.teamVariantConfig.model_variants?.map(model => model.model_name).join(', ')})`
    }

    return '';
  }
}

function compareArrays (arr1: ModelVariant[], arr2: ModelVariant[]) {
  let noMatch: boolean = true;
  
  if(arr1.length !== arr2.length){
    console.log('False because of length.')
    return false;
  }

  arr1.forEach(model =>{
    if (!arr2.some(value=> value.model_id === model.model_id) && (noMatch)){
      console.debug('False because a value was not found')
      noMatch = false;
    }
  })

  return noMatch;
}